import { jsx, Fragment } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { logger, PersistorSuspense } from '@ninja/utilities';
import { useRouter } from './useRouter2.js';

const PagePermissionCheck = ({ children, isLoggedInUser, isUserHasPermissionOnCurrentPage, onRedirectToLogin, noPermissionComponent, noAccessComponent, isUserHasAccessOnCurrentPage, onRedirectLoggedInUser, CheckIfCurrentPageIsNotLoggedInOnly, }) => {
    const { pathname, query } = useRouter();
    const noPermission = Object.keys(query).find((k) => k.toLowerCase() === 'unauthorized');
    const isCurrentPageIsNotLoggedInOnly = CheckIfCurrentPageIsNotLoggedInOnly();
    useEffect(() => {
        logger.log('[PagePermissionCheck][useEffect]', {
            pathname,
            isLoggedInUser,
            isUserHasPermissionOnCurrentPage,
        });
        if (isCurrentPageIsNotLoggedInOnly) {
            onRedirectLoggedInUser === null || onRedirectLoggedInUser === void 0 ? void 0 : onRedirectLoggedInUser();
        }
        else if (typeof window !== 'undefined' &&
            !isLoggedInUser &&
            !isUserHasPermissionOnCurrentPage &&
            isUserHasAccessOnCurrentPage) {
            onRedirectToLogin === null || onRedirectToLogin === void 0 ? void 0 : onRedirectToLogin();
        }
    }, [isLoggedInUser, isUserHasPermissionOnCurrentPage, pathname, isCurrentPageIsNotLoggedInOnly]);
    /** onRedirectLoggedInUser event should be in progress, then no UI needed  */
    if (isCurrentPageIsNotLoggedInOnly)
        return jsx(Fragment, {});
    if (typeof window !== 'undefined' && !isUserHasAccessOnCurrentPage) {
        return jsx(PersistorSuspense, { children: noAccessComponent });
    }
    if (noPermission || (isLoggedInUser && !isUserHasPermissionOnCurrentPage))
        return jsx(Fragment, { children: noPermissionComponent });
    else if (isUserHasPermissionOnCurrentPage)
        return jsx(Fragment, { children: children });
    return jsx(Fragment, {});
};

export { PagePermissionCheck };
